import { Line } from "vue-chartjs";

export default {
    extends: Line,
    data() {
        return {
            dates:[],
            values:[],
            chartDataLin: {
                labels: this.dates,
                datasets: [
                    {
                        backgroundColor: "rgba(85, 202, 185, 0.3)",
                        borderWidth: 3,
                        borderColor: '#53B3A0',
                        pointBackgroundColor: '#018e52',
                        pointBorderWidth: 1,
                        pointBorderColor: '#018e52',
                        data: this.values,
                        steppedLine: false,
                        borderJoinStyle: 'bevel',
                        capBezierPoints: true,
                        hoverBorderWidth: 0,
                        hoverBorderColor: '#53B3A0',
                        stepped: true,
                        fill: true,
                        tension: 0,
                        lineTension: 0,
                        pointStyle: 'rectRounded',
                        hoverRadius: 2,
                        radius: 2
                    }
                ]
            },
            chartOptionsLin: {
                responsive: true,
                maintainAspectRatio: false,
                title: {
                    display: false,
                    text: 'Chart.js Doughnut Chart'
                },
                scales: {
                    xAxes: [{
                        position: 'bottom',
                        gridLines: {

                        },
                        scaleLabel: {
                            display: true,
                            labelString: ''
                        },
                        ticks: {
                            maxRotation: 0,
                            reverse: false,
                            padding: 0,

                        }
                    }],
                    yAxes: [{
                        position: 'left',
                        stacked: false,
                        gridLines: {

                        },
                        scaleLabel: {
                            display: true,
                            labelString: ''
                        },
                        ticks: {
                            min: 0,
                            stepSize: 1
                        }
                    }],
                },
                plugins: {
                    zoom: {
                        pan: {
                            enabled: false,
                            mode: 'xy'
                        },
                        zoom: {
                            enabled: false,
                            mode: 'xy'
                        }
                    }
                },
                legend: {
                    display: false,
                    position: 'bottom',
                }
            }

        }
    },
    props: ['dataProp'],
    mounted() {
        this.renderChart(this.chartDataLin, this.chartOptionsLin);
    },
    created() {
        this.dataProp.forEach(element => this.dates.push(element.date))
        this.dataProp.forEach(element => this.values.push(element.data))
        this.chartDataLin.labels = this.dates
        this.chartDataLin.datasets[0].data = this.values
    },
    methods: {

    }
};